import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  CustomTag,
  DevNote,
  InfoCardNewAdv,
  InfoCardWithCircle,
  LogoLoader,
  NewTable,
  showToast,
  SmartTooltip,
  StatusTags,
  TableAdv,
} from "../../../../components";
import { Link } from "react-router-dom";
import { mapTableRows } from "../../../../utils/mapTableRows";
//
import { useDispatch } from "react-redux";
import { setEmployeeProfileUiid } from "../../../../redux/slices/employee/employeeSlice";
import { formatWords, getEmployeeId, getValueByKey } from "../../../../utils";
import { usePagination } from "../../../../hooks";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import { fetchAllPlacements } from "../../../../redux/slices/placements/placementsApi";
import dayjs from "dayjs";
import { EmployeeStatus } from "../../../../assets/data/enumData";

const Billings = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotalCount] = useState(0);
  const [benchTotalCount, setBenchTotalCount] = useState(0);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    field: "employeeId",
    direction: 1,
  });
  const [employeesTotal, setEmployeesTotal] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const { page, limit, setPage, handleLimitChange } = usePagination(25);

  // Handle sort function
  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      // Toggle between 1 (ascending) and -1 (descending)
      direction: prevSort.field === field ? -prevSort.direction : 1,
    }));
  };

  const columns = [
    {
      key: "employeeId",
      label: "Emp Code",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            //state={{ code: row.code, dataId: row._id }}
            onClick={() =>
              dispatch(setEmployeeProfileUiid(row?.employeeId?.uiid))
            }
          >
            <span className="text-linkblue">
              {getEmployeeId(
                row?.employeeId?.uiid,
                row?.employeeId?.employmentType,
              )}
            </span>
          </Link>
        </div>
      ),
      sortfun: () => handleSort("employeeId"),
    },

    {
      key: "firstName",
      label: "Emp Name",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => {
        const firstName = row?.employeeId?.firstName || "";
        const lastName = row?.employeeId?.lastName || "";
        const value = `${firstName} ${lastName}`.trim();

        return (
          <SmartTooltip
            description={value}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal
          >
            <div className="flex items-center gap-2">
              <Avatar
                alt={firstName}
                size="sm"
                outline
                src={row?.employeeId?.profilePhotoUrl}
              />

              <Link
                to="/employee/employee-profile"
                onClick={() =>
                  dispatch(setEmployeeProfileUiid(row?.employeeId?.uiid))
                }
                className="truncate max-w-[200px]"
              >
                {value}
              </Link>
            </div>
          </SmartTooltip>
        );
      },
    },
    {
      key: "clientName",
      label: "Client Name",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.jobInfo?.billClient?.businessName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-1 line-clamp-1!">
            {row?.jobInfo?.billClient?.businessName}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "billrate",
      label: "Bill Rate",
      render: (row) => (
        <div className="flex items-center gap-1">
          {row?.payments?.[row.payments.length - 1]?.billRate?.rate || 0}
        </div>
      ),
      sortfun: () => handleSort("payments.billRate.rate"),
    },
    {
      key: "payRate",
      label: "Pay Rate",
      render: (row) => (
        <div className="flex items-center gap-1">
          {row?.payments?.[row.payments.length - 1]?.payRate?.payRatePerHour ||
            0}
        </div>
      ),
      sortfun: () => handleSort("payments.payRate.payRatePerHour"),
    },
    {
      key: "percentage",
      label: "Percentage",
      render: (row) => (
        <div className="flex items-center gap-1">
          {row?.payments?.[row.payments.length - 1]?.payRate?.subpercent
            ? (row?.payments?.[row.payments.length - 1]?.payRate?.percent /
                row?.payments?.[row.payments.length - 1]?.payRate?.subpercent) *
              100
            : row?.payments?.[row.payments.length - 1]?.payRate?.percent || 0}
        </div>
      ),
      sortfun: () => handleSort("payments.payRate.percent"),
    },
    {
      key: "consultantType",
      label: "Consultant Type",
      render: (row) => (
        <div className="flex items-center gap-1">
          {row?.employeeId?.workAuthorization || "-"}
        </div>
      ),
    },
    {
      key: "emloymentType",
      label: "Employment Type",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() =>
              dispatch(setEmployeeProfileUiid(row?.employeeId?.uiid))
            }
          >
            {row?.employeeId?.workAuthorization || "-"}
          </Link>
        </div>
      ),
    },
    {
      key: "status",
      label: "Employment Status",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() =>
              dispatch(setEmployeeProfileUiid(row?.employeeId?.uiid))
            }
          >
            <StatusTags
              tag={formatWords(
                "",
                getValueByKey(row?.employeeId?.status, "EmployeeStatus"),
              )}
            />
          </Link>
        </div>
      ),
    },
    {
      key: "email",
      label: "Email ID",
      render: (row) => (
        <div className="flex items-center gap-1 text-linkblue">
          <Link
            to="/employee/employee-profile"
            onClick={() =>
              dispatch(setEmployeeProfileUiid(row?.employeeId?.uiid))
            }
          >
            {row?.employeeId?.email?.primary || "-"}
          </Link>
        </div>
      ),
    },
    {
      key: "altEmail",
      label: "Alternate Email ID",
      render: (row) => (
        <div className="flex items-center gap-1 text-linkblue">
          <Link
            to="/employee/employee-profile"
            onClick={() =>
              dispatch(setEmployeeProfileUiid(row?.employeeId?.uiid))
            }
          >
            {row?.employeeId?.email?.secondary || "-"}
          </Link>
        </div>
      ),
    },
    {
      key: "category",
      label: "Category",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() =>
              dispatch(setEmployeeProfileUiid(row?.employeeId?.uiid))
            }
          >
            {row?.employeeId?.category || "-"}
          </Link>
        </div>
      ),
    },
    {
      key: "country",
      label: "Country",
      width: "text-nowrap",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() =>
              dispatch(setEmployeeProfileUiid(row?.employeeId?.uiid))
            }
          >
            {row?.employeeId?.location?.country || "-"}
          </Link>
        </div>
      ),
    },
    {
      key: "cityState",
      label: "City/State",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => {
        const value = `${row?.employeeId?.location?.city || ""}, ${row?.employeeId?.location?.state || ""}`;
        return (
          <SmartTooltip
            description={value}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="flex items-center gap-1 line-clamp-1!">
              <Link
                to="/employee/employee-profile"
                onClick={() =>
                  dispatch(setEmployeeProfileUiid(row?.employeeId?.uiid))
                }
              >
                {row?.employeeId?.location?.city +
                  ", " +
                  row?.employeeId?.location?.state || "-"}
              </Link>
            </div>
          </SmartTooltip>
        );
      },
    },
    {
      key: "fullAddress",
      label: "Full Address",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
            description={row?.employeeId?.location?.address1}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
        <div className="flex items-center gap-1 line-clamp-1!">
          <Link
            to="/employee/employee-profile"
            onClick={() =>
              dispatch(setEmployeeProfileUiid(row?.employeeId?.uiid))
            }
          >
            {row?.employeeId?.location?.address1 || "-"}
          </Link>
        </div>
        </SmartTooltip>
      ),
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[250px]! max-w-[350px]!",
      render: (row) => (
        <SmartTooltip
          description={row.employeeId?.jobTitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-1 line-clamp-1!">
            <Link
              to="/employee/employee-profile"
              onClick={() =>
                dispatch(setEmployeeProfileUiid(row?.employeeId?.uiid))
              }
            >
              {row?.employeeId?.jobTitle || "-"}
            </Link>
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "doj",
      label: "Date of Joining",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            onClick={() =>
              dispatch(setEmployeeProfileUiid(row?.employeeId?.uiid))
            }
          >
            {dayjs(row?.employeeId?.joinDate).format("MM/DD/YYYY") || "-"}
          </Link>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const fetchAllPlacementsData = async () => {
      const res = await fetchAllPlacements({
        limit: limit,
        page: page,
        ret: "uiid employeeId clientId payments.payRate payments.billRate",
        ref: "Employee Client",
        incl: [
          "firstName lastName employmentType profilePhotoUrl workAuthorization status email category location jobTitle joinDate",
          "businessName",
        ],
        fil: {
          type: { type: "NONE", value: 1 },
          "jobInfo.status": { type: "NONE", value: 1 },
          "jobInfo.endDate": { type: "GTE", value: new Date() },
          ...(searchValue && {
              billingsSearch: {
                  type: "AG_BILLINGS_SEARCH",
                  value: [searchValue],
              }
          })
        },
        ...(searchValue && { useAggregate: true }),
        sort: { [sortConfig.field]: sortConfig.direction },
      });
      if (searchValue) {
        const groupedData = res?.data?.data?.[0];
        setData(groupedData?.data || []);
        setTotalCount(groupedData?.total?.[0]?.count || 0);
      } else {
        setData(res?.data?.data || []);
      }
    };
    const fetchPlacementsTotal = async () => {
      if (searchValue) return;
      try {
        setIsLoading(true);
        const count = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_TOTAL_COUNT,
          params: {
            coll: "Placement",
            fil: JSON.stringify({
              type: { type: "NONE", value: 1 },
              "jobInfo.status": { type: "NONE", value: 1 },
              "jobInfo.endDate": { type: "GTE", value: new Date() },
            }),
          },
        });
        setTotalCount(count?.data?.data || 0);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };
    const fetchBenchCount = async () => {
      if (searchValue) return;
      const count = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.EMPLOYEES.GET_ALL,
        params: {
          coll: "Employee",
          useAggregate: true,
          fil: JSON.stringify({
            benchEmpCount: {
              type: "AG_LOOKUP_DATA",
              value: [1, [1, 4], 1],
            },
          }),
        },
      });
      console.log("count", count?.data?.data?.[0]?.TotalCount || 0);
      setBenchTotalCount(count?.data?.data?.[0]?.TotalCount || 0);
    };
    Promise.allSettled([
      fetchAllPlacementsData(),
      fetchPlacementsTotal(),
      fetchBenchCount(),
    ])
      .then(() => {
        // do nothing
      })
      .catch((error) => {
        console.error(
          "Error in fetching placements data and total count:",
          error,
        );
        showToast("Error in fetching data", "error");
      });
  }, [page, limit, sortConfig, searchValue]);

  useEffect(() => {
    const fetchAllTotalCounts = async () => {
      try {
        const counts = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_ALL,
          params: {
            useAggregate: true,
            coll: "Placement",
            fil: JSON.stringify({
              billings: {
                type: "AG_STATS",
                value: [1, 1, dayjs().format("YYYY-MM-DD")],
              },
            }),
          },
        });
        setEmployeesTotal(counts?.data?.data || []);
      } catch (error) {
        console.error("Error in fetching total counts:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAllTotalCounts();
  }, []);

  const mappedRows = mapTableRows(data, columns);

  return (
    <div className="flex flex-col overflow-hidden">
      <TableAdv
        rows={mappedRows}
        tableId={`Employee_Billings`}
        columns={columns}
        fixedCol={2}
        serverPagination={true}
        totalCount={total}
        page={page}
        limit={limit}
        showSlNo
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        serverOnSearch={(key, value) => {
          setPage(1);
          setSearchValue(value);
        }}
        toolbarRight={{
          search:true,
          filter:true,
          add: [
            {
              component: (
                <>
                  <div className="flex gap-2">
                    <InfoCardWithCircle
                      data={[
                        {
                          "Total Billings": [
                            employeesTotal?.find(
                              (item) => item.employmentType === 1,
                            )?.total || 0,
                            employeesTotal?.find(
                              (item) => item.employmentType === 3,
                            )?.total || 0,
                          ].reduce((a, b) => a + b, 0),
                        },
                      ]}
                      size="xs"
                      color="gray"
                      colorDepth="200"
                      variant="contained"
                      noBorder={false}
                      className=""
                    />
                    <InfoCardWithCircle
                      data={[
                        {
                          "W2 Billings":
                            employeesTotal?.find(
                              (item) => item.employmentType === 1,
                            )?.total || 0,
                          // Permanents:
                          //   employeesTotal?.find(
                          //     (item) => item.employmentType === 2,
                          //   )?.total || 0,
                          "C2C Billings":
                            employeesTotal?.find(
                              (item) => item.employmentType === 3,
                            )?.total || 0,
                          Bench: benchTotalCount || 0,
                        },
                      ]}
                      size="xs"
                      color="gray"
                      colorDepth="200"
                      variant="contained"
                      noBorder={false}
                      className=""
                    />
                  </div>
                </>
              ),
            },
          ],
        }}
      />
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default Billings;
